import { useFieldArray, useFormContext } from "react-hook-form";
import { useEditorHistoryContextOptional } from "../contexts/editor-history-context";
import type { BlockEditorFormValues, Section } from "../types";


export function useRemoveBlock() {
	const { control, watch } = useFormContext<BlockEditorFormValues>();
  const history = useEditorHistoryContextOptional();

	const beforeArray = useFieldArray({
		control,
		name: "content.beforeBlocks",
		keyName: "fieldId",
	});
	const beforeBlocks = watch("content.beforeBlocks");

	const insideArray = useFieldArray({
		control,
		name: "content.insideBlocks",
		keyName: "fieldId",
	});
	const insideBlocks = watch("content.insideBlocks");

	const afterArray = useFieldArray({
		control,
		name: "content.afterBlocks",
		keyName: "fieldId",
	});
	const afterBlocks = watch("content.afterBlocks");

	const getSectionAndIndexById = (id: string): { section: Section; index: number } | null => {
		const beforeIndex = beforeBlocks.findIndex((block) => block.id === id);
		if (beforeIndex !== -1) return { section: "before", index: beforeIndex };

		const insideIndex = insideBlocks.findIndex((block) => block.id === id);
		if (insideIndex !== -1) return { section: "inside", index: insideIndex };

		const afterIndex = afterBlocks.findIndex((block) => block.id === id);
		if (afterIndex !== -1) return { section: "after", index: afterIndex };

		return null;
	}

	const removeBlock = (id: string) => {
		const { section, index } = getSectionAndIndexById(id) || {};

		switch (section) {
			case "before":
				beforeArray.remove(index);
				break;
			case "inside":
				insideArray.remove(index);
				break;
			case "after":
				afterArray.remove(index);
				break;
		}

    // Capture state AFTER the remove operation
    setTimeout(() => history?.captureState(), 0);
	};

	return { removeBlock };
}
